@let $user = authService.currentUser | async;

<nav class="nav-top">
  <div class="nav-logo">
    <a [routerLink]="['/home']">SysPromptHub</a>
  </div>

  <div class="app-row-auto gapped">
    <app-button
      class="nav-button"
      type="new"
      icon="extension"
      label="VS Code"
      description="Download SysPromptHub VS Code Extension"
      (click)="vscode.openExtensionPage($event)"
    />

    @if ($user) {
      <app-drop-down-button>
        <ng-container buttonContent>
          @let activeOrg = orgService.activeOrganization();
          <span>{{ activeOrg?.name || $user.name }}</span>
        </ng-container>

        <!-- Organization Switcher Section -->
        @if (orgService.organizations().length > 0) {
          <div class="padded tight">Organizations</div>
          @for (org of orgService.organizations(); track org.id) {
            <button
              type="button"
              [class.active]="org.id === orgService.activeOrganization()?.id"
              (click)="switchOrganization(org.id)">
              <span>{{ org.name }}</span>
            </button>
          }
          <hr/>
        }

        <!-- User Actions -->
        <button type="button" [routerLink]="['/profile']">Profile</button>
        <button type="button" disabled>Settings</button>
        <hr/>
        <button type="button" (click)="authService.logout(); $event.preventDefault()">Logout</button>
      </app-drop-down-button>
    }
  </div>
</nav>
